import React, { useEffect, useState } from "react";
import makeStyles from "@material-ui/core/styles/makeStyles";

import { useDispatch } from "react-redux";
import NewsRequests from "services/news";

import CmtCard from "@coremat/CmtCard";
import CmtCardContent from "@coremat/CmtCard/CmtCardContent";
import PurchasesTable from "./PurchasesTable";
import CmtSearch from "@coremat/CmtSearch";
import { Box, Button } from "@material-ui/core";
import { AddBox,Assessment } from "@material-ui/icons";
import AddPurchaseDialog from "./AddPurchaseDialog";
import PurchasesReportDialog from "./PurchasesReportDialog";

const useStyles = makeStyles((theme) => ({
  cardRoot: {
    [theme.breakpoints.down("xs")]: {
      "& .Cmt-header-root": {
        flexDirection: "column",
      },
      "& .Cmt-action-default-menu": {
        marginLeft: 0,
        marginTop: 10,
      },
    },
  },
  cardContentRoot: {
    padding: 0,
  },
  actionsContainer: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "20px 20px",
  },
  buttonsContainer: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
}));

const PurchasesContainer = () => {
  const classes = useStyles();
  const dispatch = useDispatch();

  const [searchVal, setSearchVal] = useState("");
  const [openAddPurchase, setOpenAddPurchase] = useState(false);
  const [openReportDialog, setOpenReportDialog] = useState(false);

  useEffect(() => {
    if (searchVal.trim().length > 0) {
      dispatch(NewsRequests.getAllPurchases(1, searchVal));
    } else {
      dispatch(NewsRequests.getAllPurchases(1));
    }
  }, [searchVal]);

  return (
    <>
      <CmtCard className={classes.cardRoot}>
        <CmtCardContent className={classes.cardContentRoot}>
          <Box className={classes.actionsContainer}>
            <Box className={classes.buttonsContainer}>
              <CmtSearch
                border={false}
                onlyIcon={false}
                iconPosition="left"
                align="left"
                placeholder="جست و جو"
                value={searchVal}
                onChange={(e) => setSearchVal(e.target.value)}
              />
              <Button
                variant="outlined"
                color="primary"
                startIcon={<AddBox />}
                onClick={() => setOpenAddPurchase(true)}
                style={{ marginRight: 14, marginBlock: "10px" }}
              >
                اضافه کردن خرید جدید
              </Button>
            </Box>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<Assessment />}
              onClick={() => setOpenReportDialog(true)}
              style={{ marginRight: 14 }}
            >
              دریافت گزارش
            </Button>
          </Box>
          <PurchasesTable
            searchMode={searchVal.trim().length > 0}
            searchInput={searchVal}
          />
        </CmtCardContent>
      </CmtCard>
      <AddPurchaseDialog
        open={openAddPurchase}
        handleClose={() => setOpenAddPurchase(false)}
      />
      <PurchasesReportDialog
        open={openReportDialog}
        handleClose={() => setOpenReportDialog(false)}
        searchString={searchVal.trim()}
      />
    </>
  );
};

export default PurchasesContainer;
